import { BladeFile, BladeFileList } from '@razorpay/blade/components';

export const findFileById = (
  fileList: BladeFile[] | BladeFileList | undefined,
  fileId: string,
): BladeFile | undefined => {
  return fileList?.find((f: BladeFile) => {
    const idMatches = f.id === fileId;
    return idMatches;
  });
};

export const updateFileStatus = (
  currentFiles: BladeFile[],
  fileId: string,
  ufhFileId: string,
  updatedStatus: BladeFile['status'],
): BladeFile[] => {
  return currentFiles.map((file: BladeFile) => {
    if (file.id === fileId && file.status === 'uploading') {
      file.status = updatedStatus;
      file.id = ufhFileId;
    }
    return file;
  });
};

export const getBase64 = (file: File): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};
